import { Availability } from "./availability.model";
import { Step1 } from "./cards";
import { Step2 } from "./step2";
import { Step3 } from "./step3";

export class Variables {

    public static get $(): any {
        return window['$'];
    }

    public static loadingDivId = "dvLoading";
    public static submittingDivId = "dvSubmittingForm";
    public static availabilitiesDivId = "dvAvailabilities";


}

const isDevMode: boolean = false;

// the function being used to fetch json files from API
export const getJsonDataFor = (fileName: string) => {
    return new Promise((resolve, reject) => {
        Variables.$.ajax({
            dataType: "json",
            url: `${isDevMode ? 'http://localhost:5000' : 'https://www.luxurychaletsmeribel.co.uk/api'}/public-files/${fileName}.json`,
        })
            .then((response) => {
                resolve(response);
            })
            .fail(() => {
                console.log(`failed to load ${fileName}`);
                Variables.$(`#${Variables.availabilitiesDivId}`).hide();
                Variables.$("#pErrorAvailabilities").show();
                reject();
            });
    });
};

export const dateToString = (date: Date, includeYear: boolean = true) => {
    let options: Intl.DateTimeFormatOptions = {
        day: "numeric"
    };
    options.month = "short";
    if (includeYear) {
        options.year = "numeric";
    }
    return date.toLocaleString("en-ie", options);
}
export const moneyToString = (money: number, includeFraction: boolean = false, currencySymbol = "€") => {
    if (money == null) {
        return "";
    }
    let options: Intl.NumberFormatOptions = {
    };
    if (includeFraction) {
        options.minimumFractionDigits = 2;
        options.maximumFractionDigits = 2;
    }
    return currencySymbol + money.toLocaleString(undefined, options);
}

export const scrollToTop = (elementId: string) => {
    Variables.$(window).scrollTop(Variables.$(`#${elementId}`).offset().top);
}



export const setStepQS = (stepName: 'step2' | 'step3' | null) => {

    //console.log('called set step method', stepName);

    const urlParams = new URLSearchParams(window.location.search);

    // if we are heading to the first step, i.e., cards
    if (stepName == null) {

        const currentStepName = urlParams.get('bookingStep');
        if (currentStepName) {
            urlParams.delete('bookingStep');

            const newUrl = new URL(window.location.href);
            newUrl.search = String(urlParams);
            window.history.replaceState({}, document.title, newUrl);
            window.onpopstate = () => {
                // If we don't do the following lines, the back button needs to pressed multiple time to work
                window.onpopstate = undefined;
                sessionStorage.removeItem('booking-state-pushed');

                // this is doing the back button
                window.history.back();
            }
        }

        return;
    }


    urlParams.set('bookingStep', stepName);

    const newUrl = new URL(window.location.href);
    newUrl.search = String(urlParams);

    if (sessionStorage.getItem('booking-state-pushed') === 'true') {
        window.history.replaceState({}, document.title, newUrl);
    } else {
        sessionStorage.setItem('booking-state-pushed', 'true');
        window.history.pushState({}, document.title, newUrl);
    }

    window.onpopstate = () => {
        onpopstate(stepName);
    };



}
const onpopstate = (callerState: 'step2' | 'step3' | null) => {

    // when the sub,it button is clicked, this pop state is called as well,
    // while we want to do all stuff below only if the BROWSER BACK button is clicked
    if (Step3.instance.submitButtonPoppingState) {
        Step3.instance.submitButtonPoppingState = false;
        return;
    }

    window.onpopstate = () => {
        window.onpopstate = undefined;
        sessionStorage.removeItem('booking-state-pushed');
        window.history.back();
    }

    // If the user clicks on the BROWSER BACK button, we reload the page. That basically leads to the first step, i.e., cards.
    setTimeout(() => {
        window.location.reload();
    }, 1);

    return;
    // //const urlParams = new URLSearchParams(window.location.search);

    // // const targetStepName = urlParams.get('bookingStep');
    // console.log(callerState);
    // // console.log(window.location.search);
    // sessionStorage.removeItem('booking-state-pushed');
    // switch (callerState) {
    //     case 'step2':
    //         Step2.instance.clickStartOverButton();
    //         window.onpopstate = () => {
    //             window.onpopstate = undefined;
    //             //window.history.back();
    //         }
    //         return;
    //     case 'step3':
    //         Step3.instance.clickBackButton();
    //         break;
    //     default:
    //         break;
    // }
    // window.onpopstate = undefined;

}
